import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import RatingCluppService from "./RantingCluppService";
import Swal from "sweetalert2";

const landingId = "CF_RATING_SERVICE";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  const prevAnswers = {};
  let lastRanking = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const itemsFromThisLanding = prevForm.items.find(
    (items) => items.landingId === landingId
  );
  if (itemsFromThisLanding) {
    const thisField = itemsFromThisLanding?.answers[0];
    const thisFieldType = thisField.type; // choice
    lastRanking = thisField[thisFieldType].value;
  }
  if (!lastRanking.value) {
    const thisField = fieldsStructure[0];
    const thisFieldType = thisField.type;
    lastRanking = thisField[thisFieldType].value;
  }

  return {
    userId: uid,
    ...prevAnswers,
    [fieldsStructure[0].field.id]: lastRanking,
    landedAt,
    prevForm,
    sessionId: session.sessionID,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
  setLoading,
}) => {
  if (session?.sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${session.sessionID}`;
      const docRef = doc(db, path);
      const prevForm = state.prevForm;

      const newLanding = {
        landingId,
        landedAt: state.landedAt,
        submittedAt: Date.now(),
      };

      const answerStructure = fieldsStructure[0];
      const fieldType = answerStructure.type;
      const filedName = answerStructure.field.id;
      answerStructure[fieldType].value = state[filedName];
      const answer = answerStructure[fieldType].value;

      if (answer.value === 0) {
        setLoading(false);
        return Swal.fire({
          icon: "warning",
          text: "Por favor, selecciona una de las calificación.",
          confirmButtonColor: "#00bbee",
        });
      }

      newLanding.answers = [answerStructure];
      const thisItemExists = prevForm.items.find(
        (item) => item.landingId === landingId
      );

      const updateData = thisItemExists
        ? [
            ...prevForm.items.filter((item) => item.landingId !== landingId),
            newLanding,
          ]
        : arrayUnion(newLanding);

      await saveFormRecord(session.sessionID, {
        ...prevForm,
        items: updateData,
      });
      await updateDoc(docRef, {
        items: updateData,
        processed: false,
      });

      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <RatingCluppService
    state={state}
    setState={setState}
    field={"CF_raiting_service_s12tg"}
  /> // Field ID
);

const nextPage = (props) =>
  `/formulario/cancelacion/referidos?uid=${props.uid}`;
const prevPage = (props) => {
  if (props.sessionId && props.prevForm) {
    const prevForm = props.prevForm;
    const lastItem = prevForm.items[prevForm.items.length - 1];
    const lastLandingID = lastItem.landingId;
    if (lastLandingID === "CF_CLAIMS_BENEFITS") {
      return `/formulario/cancelacion/siniestros?uid=${props.uid}`;
    }
    return `/formulario/cancelacion/beneficios?uid=${props.uid}`;
  }
};
const fieldsStructure = [
  {
    field: {
      id: "CF_raiting_service_s12tg",
      type: "raiting_stars",
      ref: "CF_raiting_service",
    },
    metadata: {},
    type: "raiting_stars",
    raiting_stars: {
      value: {
        label: "",
        value: 0,
      },
    },
  },
];

const ratingCluppServiceProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default ratingCluppServiceProps;
